import { useState, useEffect } from 'react';

export default function Payement() {
  const [price, setPrice] = useState(0);

  // Fonction pour formater le prix
  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return '0';
    return new Intl.NumberFormat('fr-FR').format(amount) + ' F CFA';
  };

  // Fonction utilitaire pour extraire le prix
  const extractPrice = (data) => {
    const possiblePaths = [
      'data.data.total_premium.value',
      'data.data.total_premium',
      'data.total_premium.value',
      'data.total_premium',
      'total_premium.value',
      'total_premium',
      'data',
      'price',
      'amount',
      'premium'
    ];

    for (const path of possiblePaths) {
      const keys = path.split('.');
      let value = data;
      let found = true;

      for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
          value = value[key];
        } else {
          found = false;
          break;
        }
      }

      if (found && (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value))) || (typeof value === 'object' && value && typeof value.value === 'number'))) {
        return typeof value === 'object' ? Number(value.value) : Number(value);
      }
    }

    if (typeof data === 'number') return data;
    if (typeof data === 'string' && !isNaN(Number(data))) return Number(data);
    return null;
  };

  useEffect(() => {
    const cotationResult = localStorage.getItem('cotationResult');
    if (cotationResult) {
      try {
        const result = JSON.parse(cotationResult);
        const extractedPrice = extractPrice(result);
        if (extractedPrice !== null && typeof extractedPrice === 'number' && !isNaN(extractedPrice) && extractedPrice >= 0) {
          setPrice(extractedPrice);
        }
      } catch (error) {
        console.error('Erreur lors du parsing du résultat de cotation:', error);
      }
    }
  }, []);

  return (
    <section className="py-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <img
          src="assets/images/congrat.gif"
          alt="Félicitations"
          className="mx-auto h-24"
        />
        <h1 className="mt-6 text-2xl font-normal text-primary uppercase">
          Félicitations<br />
          <span className="block font-normal">Votre souscription est confirmée !</span>
        </h1>
        <p className="mt-6 text-lg">
          Votre prime soldée est de
        </p>
        <p className="text-4xl font-bold text-black mt-2">
          {formatCurrency(price)}
        </p>

        <p className="mt-6 max-w-4xl mx-auto">
          Merci d'avoir choisi notre assurance santé Flex. <br /> 
          Votre souscription sera active dans un délai de deux (02) jours ouvrés. <br />
          Vous recevrez très prochainement l'ensemble de vos documents contractuels par mail et dans votre espace client.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="/"
            className="rounded-full border border-secondary px-6 py-3 text-secondary transition hover:bg-secondary hover:text-light"
          >
            Retour à l'accueil
          </a>
          <button className="rounded-full bg-secondary-dark px-6 py-3 text-white cursor-pointer">
            Télécharger mon reçu de payement
          </button>
        </div>
      </div>
    </section>
  );
}
